import { FilterValue, FilterValueType } from '../types';

/**
 * Filter Operator for comparing field value is starts with the filter value
 */
export function stringStartsWith<T>(
	row: T,
	fields: (keyof T)[],
	_: FilterValueType,
	filterValue: FilterValue,
	fieldProperty?: string
): boolean {
	// If filterValue is an array, recursively check if any string in the array matches
	if (Array.isArray(filterValue)) {
		return filterValue.some((value) => {
			if (typeof value === 'string') {
				return stringStartsWith(row, fields, _, value, fieldProperty);
			}
			return false;
		});
	}

	// The filter value must be a string to do starts with comparison
	if (typeof filterValue !== 'string') {
		throw new Error(`Starts With operator received invalid comparison value ${typeof filterValue}`);
	}

	const doesStartWith: boolean = fields.reduce((fieldStartsWith, field) => {
		// Since we are always using OR logic, once we find a single match the rest doesn't matter just continue
		if (fieldStartsWith) {
			return true;
		}

		let fieldValue: unknown = row[field];

		// Nullable string fields (drvId, chassisId) are null whenever unset, which is a non-match rather than an error
		if (fieldValue === undefined || fieldValue === null || fieldValue === 'undefined') {
			return false;
		}

		if (typeof fieldValue === 'object' && fieldProperty) {
			const obj = fieldValue as Record<string, unknown>;
			fieldValue = obj[fieldProperty];

			// If the property value was not found return
			if (!fieldValue) {
				return false;
			}
		}

		if (typeof fieldValue !== 'string') {
			throw new Error(`Starts With operator cannot be applied to ${typeof fieldValue}`);
		}

		return fieldValue.toLowerCase().startsWith(filterValue.toLowerCase());
	}, false);

	return doesStartWith;
}
